// Partiels : échéances de J0 (« être à J30 le jour du partiel »), progression par matière, ajout / suppression.
// « Au partiel X, être au moins à J30 » : contrainte de date pour l'ordonnanceur (le J0 des items de ces matières
// doit tomber au plus tard le partiel moins ce J). 0 = pas de contrainte.
window.actions.examSetJCible = function(id, valeur) {
    var e = window.state.exams.find(function(x) { return x.id === id; }); if (!e) return;
    e.jCible = Math.max(0, Math.min(365, parseInt(valeur, 10) || 0));
    window.saveExams(); if (window.state.showAutoPlanModal) window.renderModal();
};
// Échéance de J0 d'un item d'après les partiels à venir : la plus proche des dates « partiel − J cible ».
window.echeanceJ0 = function(item, refDateStr) {
    var specs = [item.matiere].concat(item.collegesSecondaires || []).filter(Boolean), echeance = null;
    window.activeExams(refDateStr).forEach(function(e) {
        if (!(e.jCible > 0) || !(e.specs || []).some(function(sp) { return specs.indexOf(sp) !== -1; })) return;
        var d = window.parseDateLocal(e.date); d.setDate(d.getDate() - e.jCible);
        var s = window.toYYYYMMDD(d);
        if (!echeance || s < echeance) echeance = s;
    });
    return echeance;
};
window.actions.examSetMarge = function(id, valeur) {
    var e = window.state.exams.find(function(x) { return x.id === id; }); if (!e) return;
    e.marge = Math.max(0, Math.min(365, parseInt(valeur, 10) || 0));
    window.saveExams(); window.renderContent();
};
window.saveExams = function() {
    window.storageSet('edn_exams', JSON.stringify(window.state.exams));
    window.savePrefs();
};

// --- PARTIELS : les items des matières concernées passent en tête du jour et sont épargnés par le lissage ---
window.activeExams = function(refDateStr) {
    var today = refDateStr || window.todayStr();
    return window.state.exams.filter(function(e) { return e.date && e.date >= today; }).sort(function(a, b) { return a.date.localeCompare(b.date); });
};
window.examForTask = function(task, refDateStr) {
    var exams = window.activeExams(refDateStr);
    if (!exams.length) return null;
    var id = (task.baseItemId || task.itemId || '').toString();
    var item = window.itemById(id);
    var specs = [task.matiere].concat(item ? item.collegesSecondaires : []).filter(Boolean);
    for (var i = 0; i < exams.length; i++) {
        if ((exams[i].specs || []).some(function(sp) { return specs.indexOf(sp) !== -1; })) return exams[i];
    }
    return null;
};
window.daysUntil = function(dateStr) {
    var a = window.parseDateLocal(window.todayStr()), b = window.parseDateLocal(dateStr);
    return Math.round((b - a) / 86400000);
};
// avancement d'une matière : proportion des révisions déjà validées parmi toutes celles planifiées pour cette matière
// Avancement d'une matière avant un partiel : ce qui compte, c'est le nombre d'ITEMS déjà découverts. Un item
// est « vu » quand le J0 de CHACUNE de ses sous-parties est coché. Compter les révisions (J3, J7, J30, Loop)
// mélangeait découverte et entretien : réviser trois fois le même item faisait monter la barre sans qu'un
// item de plus ait été vu — ce qui, avant un partiel, est exactement ce qu'on ne veut pas savoir.
window.progressForSpec = function(spec) {
    var parItem = {};
    window.state.tasks.forEach(function(t) {
        var base = String(t.baseItemId || t.itemId || '');
        var item = window.itemById(base);
        var specs = [t.matiere].concat(item ? item.collegesSecondaires : []).filter(Boolean);
        if (specs.indexOf(spec) === -1) return;
        var e = parItem[base] || (parItem[base] = { seq: {}, taches: 0, faites: 0 });
        e.taches++; if (t.status === 'done') e.faites++;
        if (t.type !== 'J0') return;
        // Chaque J0 de l'item compte : celui de chaque sous-partie ET celui du renforcement pédiatrie quand il y en
        // a un. L'item n'est « vu » que quand TOUS sont cochés.
        var seq = t.isDouble ? 'pediatrie' : String(t.itemId); // une sous-partie = une séquence, repérée par son itemId
        if (!(seq in e.seq)) e.seq[seq] = true;
        if (t.status !== 'done') e.seq[seq] = false;
    });
    var ids = Object.keys(parItem), total = ids.length, done = 0, taches = 0, faites = 0;
    ids.forEach(function(id) {
        var e = parItem[id];
        taches += e.taches; faites += e.faites;
        // Aucun J0 (séance supprimée à la main) : il n'y a rien à découvrir, l'item ne bloque pas le compte.
        if (Object.keys(e.seq).every(function(sq) { return e.seq[sq]; })) done++;
    });
    return { done: done, total: total, pct: total ? Math.round(done / total * 100) : 0, taches: taches, faites: faites };
};

window.actions.openExams = function() {
    window.state.examDraft = { name: '', date: '', specs: [] };
    window.state.modalConfig = { type: 'exams' };
    window.renderModal();
};
window.actions.examDraftToggleSpec = function(spec) {
    var d = window.state.examDraft;
    var nameEl = document.getElementById('exam-name'), dateEl = document.getElementById('exam-date');
    if (nameEl) d.name = nameEl.value; if (dateEl) d.date = dateEl.value;
    var i = d.specs.indexOf(spec);
    if (i === -1) d.specs.push(spec); else d.specs.splice(i, 1);
    window.renderModal();
};
window.actions.addExam = function() {
    var d = window.state.examDraft;
    var nameEl = document.getElementById('exam-name'), dateEl = document.getElementById('exam-date');
    if (nameEl) d.name = nameEl.value; if (dateEl) d.date = dateEl.value;
    if (!d.date) { alert('Indique la date du partiel.'); return; }
    if (!d.specs.length) { alert('Coche au moins une matière.'); return; }
    window.state.exams.push({ id: 'ex_' + Date.now().toString(36), name: (d.name || '').trim() || ('Partiel ' + d.specs.join(' / ')), date: d.date, specs: [].concat(d.specs) });
    window.state.exams.sort(function(a, b) { return a.date.localeCompare(b.date); });
    window.saveExams();
    window.state.examDraft = { name: '', date: '', specs: [] };
    window.renderModal(); window.renderContent(); window.renderHeader();
};
window.actions.deleteExam = function(id) {
    window.state.exams = window.state.exams.filter(function(e) { return e.id !== id; });
    window.saveExams();
    window.renderModal(); window.renderContent(); window.renderHeader();
};

// Exports : les mêmes fonctions que celles posées sur window (le code historique les lit encore là).
export const echeanceJ0 = window.echeanceJ0;
export const saveExams = window.saveExams;
export const activeExams = window.activeExams;
export const examForTask = window.examForTask;
export const daysUntil = window.daysUntil;
export const progressForSpec = window.progressForSpec;
